import React from "react";
import { connect } from "react-redux";
// import Tour from "reactour";
import * as includes from "lodash.includes";
import * as every from "lodash.every";
import { completeTour } from "../store/actions";
import Layer from "grommet/components/Layer";
import Box from "grommet/components/Box";
import Button from "grommet/components/Button";
import Heading from "grommet/components/Heading";
import Paragraph from "grommet/components/Paragraph";
import Label from "grommet/components/Label";

class DelayedRender extends React.Component {
  componentDidMount() {
    this.t1 = setTimeout(
      () =>
        this.setState({
          show: true
        }),
      this.props.delay
    );
  }

  state = {
    show: false
  };
  componentWillUnmount() {
    clearTimeout(this.t1);
  }

  render() {
    return this.state.show ? this.props.children : null;
  }
}

export const withTour = (config, options = {}) => {
  return WrappedComponent => {
    const { steps, tourId, waitFor, title, description, buttonLabel, tourImage } = config;
    const component = class extends React.Component {
      constructor(props) {
        super(props);
        this.state = {
          tourStep: 0,
          ctaOpen: false
        };
        if (title && description) {
          this.state = {
            ...this.state,
            step: 0
          };
        } else {
          this.state = {
            ...this.state,
            step: 1
          };
        }
      }
      render() {
        const { toursCompleted, completeTour, loading, dispatch, ...rest } = this.props;
        if (options.render) {
          if (!options.render(this.props)) {
            return <WrappedComponent {...rest} />;
          }
        }
        const { step, tourStep, ctaOpen } = this.state;
        let isOpen = false;
        if (!includes(toursCompleted, tourId)) {
          if (!waitFor) {
            isOpen = true;
          } else if (every(waitFor, id => includes(toursCompleted, id))) {
            isOpen = true;
          }
        }
        if (options.cta && ctaOpen) {
          return (
            <>
              <Layer closer={false} align="center" flush={false}>
                <Box align="center" pad={{ vertical: "large", horizontal: "small", between: "medium" }}>
                  {options.cta(this.props, () => {
                    completeTour(tourId);
                    this.setState({ ctaOpen: false });
                  })}
                </Box>
              </Layer>
              <WrappedComponent {...rest} />
            </>
          );
        }
        const modifiedSteps = steps.map((s, i) => ({
          ...s,
          //Modify the last step to add a finish tour button
          content:
            i === steps.length - 1 && !(s.waitForElement || s.waitForElementDissapear)
              ? () => (
                  <Box>
                    <p>{s.content}</p>
                    <Button
                      label="Terminer le tutoriel"
                      primary
                      onClick={() => {
                        if (options.cta) {
                          this.setState({
                            ctaOpen: true
                          });
                        } else {
                          completeTour(tourId);
                        }
                      }}
                    />
                  </Box>
                )
              : s.content,
          style: {
            fontFamily: "Work Sans"
          }
        }));
        const setupObservers = step => {
          const newStep = step < modifiedSteps.length - 1 ? step + 1 : step;
          const isDone = newStep === modifiedSteps.length - 1;
          if (modifiedSteps[newStep].waitForElement || modifiedSteps[newStep].waitForElementDissapear) {
            new MutationObserver((mutationRecords, observer) => {
              // Query for elements matching the specified selector
              console.log(
                `Registering a ${modifiedSteps[newStep].waitForElement ? "Appear" : "Dissappear"} MutationObserver on ${modifiedSteps[
                  newStep
                ].waitForElement || modifiedSteps[newStep].waitForElementDissapear}. Next step: ${JSON.stringify(modifiedSteps[newStep])}`
              );
              try {
                if (modifiedSteps[newStep].waitForElement) {
                  console.log(`Did ${modifiedSteps[newStep].waitForElement} appear?`);
                  if (document.querySelectorAll(modifiedSteps[newStep].waitForElement).length > 0) {
                    console.log(`Found ${modifiedSteps[newStep].waitForElement}`);
                    // clearInterval(iId);
                    if (isDone) {
                      observer.disconnect();
                      completeTour(tourId);
                      return;
                    }
                    setTimeout(() => {
                      this.setState(
                        {
                          tourStep: newStep + 1
                        },
                        () => {
                          if (!isDone) {
                            setupObservers(step + 1);
                          }
                        }
                      );
                    }, modifiedSteps[newStep].delay || 10);
                    //Once we have resolved we don't need the observer anymore.
                    observer.disconnect();
                  } else {
                    console.log("No");
                  }
                } else {
                  console.log(`Did ${modifiedSteps[newStep].waitForElementDissapear} dissappear?`);
                  if (document.querySelectorAll(modifiedSteps[newStep].waitForElementDissapear).length === 0) {
                    console.log(`Dissapeared ${modifiedSteps[newStep].waitForElementDissapear}`);
                    // clearInterval(iId);
                    if (isDone) {
                      observer.disconnect();
                      completeTour(tourId);
                      return;
                    }
                    setTimeout(() => {
                      this.setState(
                        {
                          tourStep: newStep + 1
                        },
                        () => {
                          if (!isDone) {
                            setupObservers(step + 1);
                          }
                        }
                      );
                    }, modifiedSteps[newStep].delay || 10);
                    //Once we have resolved we don't need the observer anymore.
                    observer.disconnect();
                  } else {
                    console.log("No");
                  }
                }
              } catch (e) {
                console.error(e);
              }
            }).observe(document.documentElement, {
              childList: true,
              subtree: true
            });
          }
        };
        return (
          <React.Fragment>
            {isOpen && !loading ? (
              step === 0 ? (
                <Layer closer={false} align="center" flush={false}>
                  <Box align="center" pad={{ vertical: "large", horizontal: "small", between: "medium" }}>
                    <Heading tag="h2">Tutoriel: {title}</Heading>
                    {tourImage ? <img src={tourImage} /> : null}
                    <Box>
                      <Paragraph size="large">{description}</Paragraph>
                      <Paragraph size="medium">
                        Astuce: Cliquez sur les flèches de la fenètre pour changer d'étape ou utiliser les flèches de votre clavier.
                      </Paragraph>
                    </Box>
                    <Button
                      label={buttonLabel ? buttonLabel : "Lancer le tutoriel!"}
                      fill
                      primary
                      onClick={() => {
                        if (options.beforeStart) {
                          options.beforeStart(dispatch);
                        }
                        this.setState({ step: 1 });
                      }}
                    />
                    {/* <Button
                      label={"Non, je veux passer ce tutoriel"}
                      fill
                      onClick={() => {
                        completeTour(tourId);
                      }}
                    /> */}
                  </Box>
                </Layer>
              ) : (
                <DelayedRender delay={100}>
                  {/* <Tour
                    nextStep={() => {
                      setupObservers(tourStep);
                      if (modifiedSteps[tourStep].waitForElement || modifiedSteps[tourStep].waitForElementDissapear) {
                        return;
                      }
                      this.setState({
                        tourStep: tourStep < modifiedSteps.length - 1 ? tourStep + 1 : tourStep
                      });
                    }}
                    prevStep={() => {
                      if (modifiedSteps[tourStep - 1].waitForElement || modifiedSteps[tourStep - 1].waitForElementDissapear) {
                        return;
                      }
                      let newStep = tourStep > 0 ? tourStep - 1 : tourStep;
                      this.setState({
                        tourStep: newStep
                      });
                    }}
                    nextButton={
                      modifiedSteps[tourStep] &&
                      (modifiedSteps[tourStep].waitForElement || modifiedSteps[tourStep].waitForElementDissapear) ? (
                        <Box direction="row" align="center">
                          <Label className="no-margin" size="small">
                            En attente de votre action
                          </Label>
                        </Box>
                      ) : null
                    }
                    goToStep={tourStep}
                    disableKeyboardNavigation={["esc"]}
                    disableDotsNavigation={true}
                    showCloseButton={false}
                    steps={modifiedSteps}
                    disableInteraction={modifiedSteps[tourStep] && modifiedSteps[tourStep].disableInteraction}
                    accentColor={"#2e5bec"}
                    rounded={3}
                    closeWithMask={false}
                    isOpen={true}
                    forceScroll={modifiedSteps[tourStep] && modifiedSteps[tourStep].forceScroll}
                    scrollOffset={modifiedSteps[tourStep] && modifiedSteps[tourStep].scrollOffset}
                    onRequestClose={() => completeTour(tourId)} */}
                  />
                </DelayedRender>
              )
            ) : null}
            <WrappedComponent {...rest} />
          </React.Fragment>
        );
      }
    };
    const mapStateToProps = state => {
      return {
        toursCompleted: state.onboarding.toursCompleted,
        loading: state.onboarding.loading
      };
    };
    const mapDispatchToProps = dispatch => {
      return {
        completeTour: tourId => {
          dispatch(completeTour(tourId));
        },
        dispatch
      };
    };
    return connect(mapStateToProps, mapDispatchToProps)(component);
  };
};
